export class ClickScrollMenu {
    constructor(optionalOptions = {}) {
        this._blocks = document.querySelectorAll('.menu-list-chooses--li a');

        if (!this._blocks) {
            this.destructor();
            return true;
        }

        let elID;
        let element;
        let y;
        let lists = document.querySelectorAll('.menu-list-chooses--li');

        this._blocks.forEach((item) =>
            item.addEventListener('click', function(event) {
                event.preventDefault()
                event.stopPropagation();

                elID = item.dataset.id;
                element = document.getElementById(elID);

                if (element) {
                    y = element.offsetTop + (-50);

                    window.scrollTo({top: y, behavior: 'smooth'});

                    setTimeout(() => {
                        lists.forEach((item) => item.classList.remove('active'));
                        item.parentElement.classList.add('active');
                    }, 300);
                }
            }));
    }

    destructor() {
        this._blocks = null;
    }
}

export default new ClickScrollMenu();